import { defineFcm } from '../shared/factory';

export const FCM_STARTER_SAP_PHONE_COLLECTION = defineFcm('starter_sap_phone_collection')
	.asEnum(['off', 'optional', 'mandatory'])
	.withDefault('off')
	.toConfig({
		owner: 'TBD',
		scope: 'corgi-front-end',
		context: 'Start A Petition Page',
		description: `This controls the validation rule for the phone_collection step in the SAP flow.
		The value will determine whether the step is:
		- "off" - The step will not be shown.
		- "optional" - The step will be shown, but not require a valid phone number to proceed.
		- "mandatory" - The step will be shown and require a valid phone number to proceed.`,
	});
